/* FIXCOMART - SALE BADGE PERCENTAGE V3 */
(() => {
  "use strict";

  function parsePrice(text) {
    const digits = String(text || "").replace(/\D/g, "");
    return digits ? Number(digits) : 0;
  }

  function updateBadge(badge) {
    const card = badge.closest(
      ".card-wrapper, .product-card-wrapper, .card"
    );

    if (!card) return;

    const oldPriceEl = card.querySelector(
      ".price__sale .price-item--regular"
    );

    const salePriceEl = card.querySelector(
      ".price__sale .price-item--sale"
    );

    if (!oldPriceEl || !salePriceEl) return;

    const oldPrice = parsePrice(oldPriceEl.textContent);
    const salePrice = parsePrice(salePriceEl.textContent);

    if (
      !oldPrice ||
      !salePrice ||
      oldPrice <= salePrice
    ) return;

    const discount = Math.round(
      ((oldPrice - salePrice) / oldPrice) * 100
    );

    if (discount > 0 && discount < 100) {
      const text = `-${discount}%`;

      if (badge.textContent.trim() !== text) {
        badge.textContent = text;
      }
    }
  }
    // FIXCOMART - DISKON DI PRODUCT DETAIL PAGE
  function updateProductPageBadge(badge) {
    const priceContainer = badge.closest(".price");
    if (!priceContainer) return;

    const oldPriceEl = priceContainer.querySelector(
      ".price__sale .price-item--regular"
    );

    const salePriceEl = priceContainer.querySelector(
      ".price__sale .price-item--sale"
    );

    if (!oldPriceEl || !salePriceEl) return;

    const oldPrice = parsePrice(oldPriceEl.textContent);
    const salePrice = parsePrice(salePriceEl.textContent);

    if (!oldPrice || !salePrice || oldPrice <= salePrice) return;

    const discount = Math.round(
      ((oldPrice - salePrice) / oldPrice) * 100
    );

    if (discount > 0 && discount < 100) {
      const text = `-${discount}%`;

      if (badge.textContent.trim() !== text) {
        badge.textContent = text;
      }
    }
  }

  function updateAll() {
    // Badge product card - tetap
    document.querySelectorAll(
      ".card__badge .badge"
    ).forEach(updateBadge);

    // Badge product detail page - tambahan
    document.querySelectorAll(
      ".price__badge-sale"
    ).forEach(updateProductPageBadge);
  }

  let scheduled = false;

  function scheduleUpdate() {
    if (scheduled) return;

    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      updateAll();
    });
  }

  function init() {
    updateAll();

    new MutationObserver(scheduleUpdate).observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      init,
      { once: true }
    );
  } else {
    init();
  }

  console.log("[Fixco Sale Badge V3] Loaded");
})();